<!-- Offline notice -->
@if (showOfflineNotice$ | async) {
  <div class="offline-notice">
    <p>⚠️ Je bent offline, de site werkt niet volledig.</p>
  </div>
}

<!-- The whole site needs to be inside the MatSidenavContainer -->
<mat-sidenav-container [class.black-bg]="showBlack$ | async" style="background-color: var(--alt-prim-color, white);">
  <!-- Sidenav menu -->
  <mat-sidenav mode="over" #sidenav (click)="sidenav.toggle()">
    <mat-nav-list>
      <!-- Button to close sidenav -->
      <button mat-icon-button class="close-button">
        <mat-icon>close</mat-icon>
      </button>

      <a mat-list-item routerLink="/"><mat-icon>home</mat-icon> Dashboard</a>
      <!-- Buttons for the mobile menu -->
      @for (button of buttons; track button) {
        @if (button.visible) {
          @if (!button['path']) {
            <a mat-list-item>
              {{ button.label }}
            </a>
          }
          @if (button['path']) {
            <a mat-list-item [routerLink]="button['path']">
              {{ button.label }}
            </a>
          }
          @for (child of button['children']; track child) {
            @if ((child.visible | async) && !child.external) {
              <a
                mat-list-item
                [routerLink]="child['path'] ? child['path'] : []"
                class="child"
                >
                &nbsp;&nbsp;{{ child.label }}
              </a>
            }
            @if ((child.visible | async) && child.external) {
              <a
                mat-list-item
                [href]="child['path']"
                class="child"
                >
                &nbsp;&nbsp;{{ child.label }}
              </a>
            }
          }
        }
      }
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    @if (showHeader$ | async) {
      <mat-toolbar style="background-color: var(--alt-sec-color, white);">
        <!-- First row of the toolbar -->
        <mat-toolbar-row class="first-row">
          @if (authService.userLoggedIn | async) {
            <button
              mat-icon-button
              (click)="sidenav.toggle()"
              fxHide.gt-sm
              >
              <mat-icon>menu</mat-icon>
            </button>
          }
          <!-- Logo -->
          <a class="logo" routerLink="/">
            <img src="/assets/images/logo.png" alt="Logo ORCA" />
          </a>
          <div fxFlex></div>
          <!-- Inloggen button -->
          @if ((authService.userLoggedIn | async) === false) {
            <button
              mat-button
              routerLink="/sign-in"
              >
              Inloggen
            </button>
          }
          @if ((authService.userLoggedIn | async) === true) {
            <app-notification-center
            ></app-notification-center>
          }
          <!-- User menu -->
          @if (user$ | async; as user) {
            <!-- <button mat-button (mousemove)="move($event, $event.target)" (mouseleave)="leave($event, $event.target)" (click)="joinWebCie($event.target)" class="user-menu">Join de WebCie</button> -->
            <button mat-button [matMenuTriggerFor]="userMenu" class="user-menu">
              <span class="member-name"
                ><app-member-name [member]="user"></app-member-name
              ></span>
              <app-member-picture
                [member]="user"
                [size]="40"
                class="profile-picture"
              ></app-member-picture>
            </button>
            <mat-menu
              #userMenu="matMenu"
              xPosition="before"
              [overlapTrigger]="false"
              >
              @if (showAdmin$ | async) {
                <button
                  mat-menu-item
                  routerLink="/admin"
                  >
                  <mat-icon>build</mat-icon> Admin functies
                </button>
              }
              <button mat-menu-item [routerLink]="'/members/settings'">
                <mat-icon>settings</mat-icon> Instellingen
              </button>
              <button mat-menu-item [routerLink]="'/members/' + user.memberID">
                <mat-icon>person</mat-icon> Mijn profiel
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item routerLink="/sign-out">
                <mat-icon>exit_to_app</mat-icon> Uitloggen
              </button>
            </mat-menu>
          }
        </mat-toolbar-row>
        @if (authService.userLoggedIn | async) {
          <mat-toolbar-row
            fxHide.lt-md
            class="second-row"
            >
            <!-- Navigation menu -->
            <button mat-icon-button routerLink="/" aria-label="Startpagina">
              <mat-icon>home</mat-icon>
            </button>
            @for (button of buttons; track button) {
              @if (button.visible) {
                @if (!button['path'] && !button['children']) {
                  <button mat-button>
                    {{ button.label }}
                  </button>
                }
                @if (button['path'] && !button['children']) {
                  <button
                    mat-button
                    [routerLink]="button['path']"
                    >
                    {{ button.label }}
                  </button>
                }
                <mat-menu #childMenu="matMenu" [overlapTrigger]="false">
                  @for (child of button['children']; track child) {
                    @if ((child.visible | async) && !child.external) {
                      <button
                        mat-menu-item
                        [routerLink]="child['path'] ? child['path'] : []"
                        >
                        {{ child.label }}
                      </button>
                    }
                    @if ((child.visible | async) && child.external) {
                      <a
                        [href]="child['path']"
                        class="external-button"
                        >
                        <button mat-menu-item>
                          {{ child.label }}
                        </button>
                      </a>
                    }
                  }
                </mat-menu>
                @if (!button['path'] && button['children']) {
                  <button
                    mat-button
                    [matMenuTriggerFor]="childMenu"
                    >
                    {{ button.label }}
                  </button>
                }
              }
            }
            <ng-container>
              <img src="/assets/images/wapen.svg" alt="Wapen van Orca" class="weapon">
            </ng-container>
          </mat-toolbar-row>
        }
      </mat-toolbar>
    }

    @if ((loader.progress$ | async) > 0) {
      <mat-progress-bar
        mode="determinate"
        [value]="loader.progress$ | async"
      ></mat-progress-bar>
    }

    <div
      [class.backdrop]="showBackdrop$ | async"
      fxLayout="column"
      fxLayoutAlign="center center"
      style="background-color: var(--alt-prim-color, white);"
      >
      <div fxLayout="row" fxLayoutAlign="center" fxFlex="1 0 auto" fxFlexFill>
        <div
          [fxFlex]="(fullWidth$ | async) ? '0 1 100%' : '0 1 1400px'"
          [class]="(fullWidth$ | async) ? '' : 'container-gutter'"
          >
          <router-outlet></router-outlet>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
